<div>
    <mat-spinner class="pulse"></mat-spinner>
</div>
